// Operaciones sobre la definición en edición (sources / fields / maps). Puras sobre el dto que reciben:
// las llama el editor dentro de history.mutate(). El orden de las conexiones de un campo en
// dto.maps es su orden de preferencia (el motor usa la primera pregunta informada) y el backend
// lo conserva al guardar.

export const targetKey = (cls, field) => `${cls}#${field}`;

export const ruleOf = (d, cls, field) => d.fields.find((f) => f.entityClass === cls && f.fieldName === field) || null;

/** Regla del campo; si no la tiene, la crea (último valor; pregunta vacía o sin la pregunta: no tocar). */
export function ensureRule(d, cls, field) {
  let r = ruleOf(d, cls, field);
  if (!r) {
    r = { entityClass: cls, fieldName: field, mergeMode: 'last', onEmpty: 'keep', onMissing: 'keep' };
    d.fields.push(r);
  }
  return r;
}

export function setRule(d, cls, field, patch) {
  Object.assign(ensureRule(d, cls, field), patch);
}

/** Índices en dto.maps de las conexiones de un campo, en orden de preferencia. */
export const chainIdx = (d, cls, field) => d.maps.reduce((acc, m, i) => {
  if (m.entityClass === cls && m.fieldName === field) acc.push(i);
  return acc;
}, []);

const has = (d, alias, cls, field) => d.maps.some((m) => m.sourceAlias === alias && m.entityClass === cls && m.fieldName === field);

/** Conecta una pregunta a un campo (al final de su cadena). @returns 'ok' | 'exists' */
export function connect(d, alias, cls, field) {
  if (has(d, alias, cls, field)) return 'exists';
  d.maps.push({ sourceAlias: alias, entityClass: cls, fieldName: field });
  ensureRule(d, cls, field);
  return 'ok';
}

export function removeMap(d, idx) {
  d.maps.splice(idx, 1);
}

export function addSource(d, questId) {
  if (d.sources.some((s) => s.questId === questId)) return 'exists';
  d.sources.push({ questId, keyMode: 'origin', idAlias: null, originAlias: null, originText: null, priority: d.sources.length + 1, enabled: true });
  return 'ok';
}

export function removeSource(d, questId) {
  d.sources = d.sources.filter((s) => s.questId !== questId);
  renumberSources(d);
}

/** La prioridad es la posición: ordena por (prioridad, posición) y numera 1..n (sin empates ni huecos). */
export function normalizeSources(d) {
  d.sources = d.sources.map((s, i) => ({ s, i })).sort((a, b) => (a.s.priority || 1) - (b.s.priority || 1) || a.i - b.i).map((x) => x.s);
  renumberSources(d);
}

export function moveSource(d, from, to) {
  const [s] = d.sources.splice(from, 1);
  d.sources.splice(to, 0, s);
  renumberSources(d);
}

function renumberSources(d) {
  d.sources.forEach((s, i) => { s.priority = i + 1; });
}

export function patchSource(d, questId, patch) {
  const s = d.sources.find((x) => x.questId === questId);
  if (s) Object.assign(s, patch);
}

/** Quita las conexiones y reglas de una clase (p. ej. una que ya no es extensión de la raíz). */
export function removeClass(d, cls) {
  d.maps = d.maps.filter((m) => m.entityClass !== cls);
  d.fields = d.fields.filter((f) => f.entityClass !== cls);
}
